<template>
  <div v-if="dialogVisible"
       :class="[isSmall?'material-batch-upload-dialog-small':'material-batch-upload-dialog']"
       ref="refMaterialBatchUploadDialog">
    <div class="batch-upload-dialog-main"
         v-show="!isSmall"
         v-loading="showLoading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         :style="[{width:titleWidth}]">
      <div class="batch-upload-dialog-title">
        <span>{{ title }}</span>
        <i class="el-dialog__close el-icon el-icon-close"
           style="width: 18px; height: 18px; cursor: pointer;"
           @click.stop="hideDialog"></i>
      </div>
      <div class="batch-upload-dialog-content">
        <!-- 上传前-->
        <materialUploadView
          ref="materialUploadViewRef"
          v-show="matchStep==0||matchStep==1||matchStep==2"
          :mediateId.sync="mediateId"
          :queryParams.sync="queryParams"
          :isSingleCase.sync="isSingleCase"
          :channel='channel'
          :isDocUpload.sync="isDocUpload"
          :effect="effect"
          @uploadProgress="uploadProgress"
          @fileMatchRate="fileMatchRate"
          @uploadFail="uploadFail"
        ></materialUploadView>
        <!-- 上传中-->
        <!-- 匹配中-->
        <materialUploading
          v-show="matchStep==3"
          :matchProgress.sync="matchProgress"
          :allFileCount.sync="allFileCount"
          :successFileCount.sync="successFileCount"
          :failFileCount.sync="failFileCount"
          style="height: 356px;"
          @clickSmall="clickSmall"
          @clickCancel="clickCancel"
        ></materialUploading>
        <!-- 上传结果-->
        <materialUploadResult v-show="matchStep==4"
                              :allUploadCount.sync="allFileCount"
                              :isSingleCase="isSingleCase"
                              :queryParams.sync="queryParams"
                              :isDocUpload.sync="isDocUpload"
                              ref="refUploadResult"
                              @clickRetry="clickRetry"
        ></materialUploadResult>
      </div>
    </div>
    <div v-show="isSmall" class="batch-upload-dialog-small-main">
      <div class="step-third-circle-small" @click="clickEnlarge">
        <img class="img-circle-small" src="@/assets/image/batch-upload-dialog/ic_circle.png">
        <img class="img-circle-center-small" src="@/assets/image/batch-upload-dialog/ic_circle_center.png">
        <span class="span-progress-small">{{ `${matchProgress ? matchProgress.toFixed(2) : 0}%` }}</span>
      </div>
    </div>

  </div>
</template>
<!--材料批量上传弹窗-->
<script>
import materialUploadView from '@/pages/case-import/meterial-upload/material-upload-view.vue';
import materialUploading from '@/pages/case-import/meterial-upload/material-uploading.vue';
import materialUploadResult from '@/pages/case-import/meterial-upload/material-upload-result.vue';

/**
 * 前端excel导出
 */

export default {
  name: 'material-batch-upload-dialog',
  components: {
    materialUploadView,
    materialUploading,
    materialUploadResult,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },

    /**
     *  {  params: {
          "actId": '',
          "agtActId": '',
          "batchId": '',
          "channel": "brt",
          "cond": "",//暂时没有
          reason: '',//不通过原因
          "excludeIds": [],//不包含在内
          "isFilterResult": '',
          "mediateIds": [],//包含在内
          "status": '',
        },
     isSingleCase: '',
     mediateId: '',//选择了单个案件}
     */
    queryParams: {// 入口查询参数-业务
      type: Object,
      default: () => {
        return {};
      }
    },
    targetData: {// 需要执行上传操作的文件数据
      type: Object,
      default: () => {
        return {};
      }
    },
    // 渠道，brt:保融通，mediate_admin_upload:调解管理人上传，mediate_mediator：调解员
    channel: {
      type: String,
      default: ''
    },
    handlerFunc: {// 外部响应方法
      type: Function
    },
    // 主题 light / dark
    effect: {
      type: String,
      default: 'light'
    }
  },
  data() {
    return {
      title: '批量上传',
      titleWidth: '635px',
      isSmall: false,
      showLoading: false,
      matchStep: 0, // 匹配步骤 0初始化、1文件上传／案例下载弹框、2拖拽上传效果、3上传匹配中、4结果样式
      matchProgress: 0,
      allFileCount: 0,
      successFileCount: 0,
      failFileCount: 0,
      mediateId: '',
      isSingleCase: false,
      isDocUpload: false, // 是否文书批量上传模式
      queryTaskTimer: 0,
      taskStatus: '', // 1未开始，2进行中，3暂停，4结束，5忽略，6任务异常
    };
  },
  watch: {
    dialogVisible() {
      this.init();
    },
    matchProgress(n) {
      if (n === 50) {
        this.sendReport(1);
      }
    }
  },
  created() {
    // this.init()
  },
  methods: {
    sendReport(status) {
      this.$store.dispatch('SetLogData', {
        map: {
          et: new Date().getTime(),
          status
        }
      });
      this.$store.dispatch('SendReport', this.$reportJs);
    },
    // 中断上传 bug - 10714
    abortUpload(succ_cb) {
      console.log('this.matchStep', this.matchStep);
      if (this.matchStep != 3) {
        succ_cb && succ_cb();
      } else {
        const html = `<div class="ept-second-comfirm-wapper">
          <p class="ept-second-comfirm-title"><img class="ept-second-comfirm-img" src="${require('@/assets/image/warning.png')}" alt="">注意</p>
          <div class="ept-second-comfirm-body">有文件正在上传，确定要中断吗？</div>
        </div>`;
        this.$confirm(html, '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          // type: 'warning'
          dangerouslyUseHTMLString: true,
          showClose: false,
          customClass: 'ept-second-comfirm-dialog'
        })
          .then(() => {
            this.clearAll(true);
            succ_cb && succ_cb();
          });
      }
    },
    init() {
      console.log('queryParams', this.queryParams);
      if (this.dialogVisible) {
        document.body.style.overflow = 'hidden';
        // 如果当前是最小化处理，默认最大化
        if (this.queryParams) {
          this.isSingleCase = this.queryParams.isSingleCase ? this.queryParams.isSingleCase : false;
          this.mediateId = this.queryParams.mediateId ? this.queryParams.mediateId : '';
          this.isDocUpload = this.queryParams.isDocUpload ? this.queryParams.isDocUpload : false;
          this.title = this.isDocUpload ? '文书批量上传' : '材料批量上传';
        }
        console.log('this.isDocUpload', this.isDocUpload);

        this.syncTaskStatus();
        // setTimeout(()=>{this.createUploadResult('42457379560378369')},3000)
      }
    },

    clickVisible() {
      // 判断一下，当前如果是缩小模式，则需要放大处理
      this.$nextTick(() => {
        if (this.isSmall) {
          this.isSmall = false;
        }
      });
    },

    hideDialog() {
      this.$confirm('是否关闭批量材料上传弹窗', '注意')
        .then(res => {
          this.sendReport(0);
          this.clearAll(true);
          this.$emit('clickClose');
          this.dialogVisible = false;
          document.body.style.overflow = 'auto';
          this.$bus.$emit('caseHandlingData');
          this.$store.dispatch('');
        });
    },

    clearTaskTimer() {
      if (this.queryTaskTimer) {
        clearInterval(this.queryTaskTimer);
      }
    },

    clearAll(needCancel) {
      this.clearTaskTimer();
      this.matchStep = 0;
      this.matchProgress = 0;
      this.allFileCount = 0;
      this.successFileCount = 0;
      this.failFileCount = 0;
      this.title = '批量上传';
      this.titleWidth = '635px';
      this.taskStatus = 1;
      this.showLoading = false;
      this.$refs.materialUploadViewRef.clearFile();
      if (this.$refs.materialUploadViewRef && needCancel) {
        this.$refs.materialUploadViewRef.cancel();
      }
    },

    clickEnlarge() {
      this.isSmall = false;
      document.body.style.overflow = 'hidden';
    },

    clickCancel() {
      this.hideDialog();
    },

    clickSmall() {
      this.isSmall = true;
      document.body.style.overflow = 'auto';
    },
    clickRetry() {
      this.clearAll(false);
      this.matchStep = 1;
    },
    uploadFail() {
      this.$message.error('没有找到符合要求的文件');
      this.clickRetry();
    },
    uploadProgress(progress) {// 文件上传中
      if (this.matchStep != 3) {
        this.matchStep = 3;
      }
      this.matchProgress = Number(progress) / 2;
    },
    fileMatchRate(res) {// 文件匹配中
      this.matchProgress = 50;
      if (this.matchStep != 3) {
        this.matchStep = 3;
      }
      if (!res.showRate) {
        if (res.result) {
          // 轮询匹配进度
          this.queryTaskRate(res.taskId);
        } else {
          if (res.code === 46403) {
            this.$message.error('无权限');
          } else {
            this.$message.error(res.msg ? res.msg : '文件匹配出错，请重试');
          }
          this.matchProgress = 100;
          const timer = setTimeout(() => {
            this.createUploadResult(res.taskId, {});
            clearTimeout(timer);
          }, 3000);
        }
      }
    },
    queryTaskRate(taskId) {
      this.queryTaskTimer = setInterval(() => {
        this.queryTaskRequest(taskId);
      }, 3000);
    },

    queryTaskRequest(taskId) {
      this.$api.queryFileMatchTask({taskId})
        .then(res => {
          if (this.showLoading) {
            this.showLoading = false;
          }
          if (res && res.code == 200 && res.data) {
            let {
              failCount,
              percentage,
              startTime,
              successCount,
              taskStatus,
              totalCount,
              matchedCaseFileCount,
              matchedCaseCount,
              notMatchedFileCount,
            } = res.data;
            this.failFileCount = failCount;
            this.successFileCount = successCount;
            this.allFileCount = totalCount;
            this.taskStatus = taskStatus;// 当前匹配任务状态

            percentage = percentage ? percentage / 2 : 0;
            // 1未开始，2进行中，3暂停，4结束，5忽略，6任务异常
            switch (this.taskStatus) {
              case 1:
                break;
              case 2:
                break;
              case 3:
                if (this.matchStep != 3) {
                  this.matchStep = 3;
                }
                this.matchProgress = 50 + percentage;
                break;
              case 4:
              case 5:
                this.matchProgress = 100;
                this.clearTaskTimer();
                const timer = setTimeout(() => {
                  this.createUploadResult(taskId, {
                    totalCount,
                    successCount,
                    failCount,
                    matchedCaseCount,
                    matchedCaseFileCount,
                    notMatchedFileCount,
                  });
                  clearTimeout(timer);
                }, 3000);
                // 任务结束，展示结果(根据当前dialog状态展示)
                break;
              case 6:
                // 任务结束，展示结果(根据当前dialog状态展示)
                this.matchProgress = 50 + percentage;
                this.clearTaskTimer();
                const timerFail = setTimeout(() => {
                  this.createUploadTaskFail(taskId);
                  clearTimeout(timerFail);
                }, 3000);
                break;
            }
          }
        });
    },


    createUploadTaskFail(taskId) {
      this.$api.queryFileMatchTaskStatus({taskId})
        .then(res => {
          if (res && res.code == 200 && res.data) {
            this.$message.error(res.data.taskDesc ? res.data.taskDesc : '当前匹配任务出现错误，请重试');
          } else {
            this.$message.error(res && res.msg ? res.msg : '当前匹配任务出现错误，请重试');
          }
          this.createUploadResult(taskId, {});
        }, err => {
          this.$message.error(err && err.msg ? err.msg : '当前匹配任务出现错误，请重试');
          this.createUploadResult(taskId, {});
        });
    },

    createUploadResult(taskId, matchData) {
      if (!matchData) {
        matchData = {};
      }
      this.matchStep = 4;// 展示结果处理
      this.titleWidth = '1100px';
      // 分页查询任务明细
      this.$nextTick(() => {
        if (this.$refs.refUploadResult) {
          this.showLoading = false;
          this.$refs.refUploadResult.showResult(taskId, () => {
            this.showLoading = false;
          }, matchData);
        }
      });
      // 更新任务状态
      this.$api.updateFileMatchTaskStatus(taskId);

      this.$emit('uploadComplete');
      this.$bus.$emit('uploadComplete');
      if (typeof this.handlerFunc === 'function') {
        this.handlerFunc();
      }
    },

    // 同步任务状态
    syncTaskStatus(complete) {
      this.showLoading = false;
      this.$api.getCurrentFileMatchTask()
        .then(res => {
          this.showLoading = false;
          complete ? complete() : '';
          if (res && res.code == 200 && res.data) {
            const taskId = res.data.taskId;
            const uploadType = res.data.uploadType;
            console.log('uploadType', uploadType);
            if (uploadType != undefined) {
              this.title = uploadType == 1 ? '文书批量上传' : '材料批量上传';
              this.isDocUpload = uploadType == 1;
            }
            if (taskId) {
              this.showLoading = false;
              this.queryTaskRate(taskId);
              // this.$confirm('当前存在正在执行的匹配，是否查看匹配情况').then(() => {
              //
              // }).catch(() => {
              //
              // })
            }
          }
        }, err => {
          this.showLoading = false;
          complete ? complete() : '';
        });
    },
  },

};
</script>

<style lang="scss" rel="stylesheet/scss">
//和文书批量上传公用一套css
.material-batch-upload-dialog {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.64);
}

.batch-upload-dialog-main {
  display: flex;
  flex-direction: column;
  background: #f8f8f8;
}

.batch-upload-dialog-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 24px;
  padding-left: 40px;
  height: 56px;
  border-bottom: 1px solid #e8e8e8;
}

.batch-upload-dialog-content {
}


/**
缩小后样式
 */

.material-batch-upload-dialog-small {
  position: fixed;
  top: calc(50vh - 34px);
  right: 0;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
}

.batch-upload-dialog-small-main {
  width: 68px;
  height: 68px;
}

</style>
